















import Vue from 'vue'
import ChatNavigationView from '../../messenger/ChatNavigationView.vue'
import EventItem from './EventItem.vue'

export default Vue.extend({
  components: {
    EventItem,
    ChatNavigationView
  },
  computed: {
    item() {
      return this.$store.state.events.items[this.$route.params.eventId]
    },
    channel() {
      const item = this.$store.state.events.items[this.$route.params.eventId]
      return this.$store.state.message_channel.items[item.message_channel_id]
    }
  }
})
